import React from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

interface UpgradePromptProps {
  onUpgradeClick: () => void;
}

// Replaced RateLimitMessage with a simpler UpgradePrompt component
const UpgradePrompt: React.FC<UpgradePromptProps> = ({ onUpgradeClick }) => {
  const { tier } = useSubscription();
  
  // Open the alpha upgrade page in a new tab
  const handleUpgradeClick = () => {
    window.open('/alpha-upgrade', '_blank');
  };
  
  return (
    <div className="fixed bottom-20 left-0 right-0 flex justify-center px-4 z-30 lg:left-64">
      <div className="max-w-xl w-full rounded-lg p-6 bg-slate-700 text-slate-100 shadow-lg border border-slate-600">
        <div className="flex flex-col items-center text-center gap-3">
          <div className="flex items-center gap-2">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-5 w-5 text-amber-400" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path 
                fillRule="evenodd" 
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" 
                clipRule="evenodd" 
              />
            </svg>
            <div className="text-lg text-amber-400 font-semibold">
              Upgrade to Alpha
            </div>
          </div>
          
          <p className="text-slate-300">
            Upgrade to Alpha for unlimited messages, no ads, and faster responses.
          </p>
          
          <div className="flex flex-col items-center gap-3">
            <button
              onClick={handleUpgradeClick}
              className="px-6 py-2 bg-emerald-500 text-slate-900 rounded-md hover:bg-emerald-400 transition-colors font-medium shadow-sm"
            >
              Upgrade to Alpha
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;
